import { Component, OnInit, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';
import { AppAuthService } from '@/services/app/auth.service';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [RouterModule, ButtonModule],
  template: `
    <div class="bg-surface-0 dark:bg-surface-900 h-screen flex flex-col justify-center items-center text-center px-6">
    <div app-logo></div>
      <h2 class="text-2xl font-semibold text-surface-700 dark:text-surface-200 mb-4">Logging you out...</h2>
      <p class="text-surface-500 dark:text-surface-400 mb-6">If nothing happens, click below to log in again.</p>
      <p-button label="Log in now" (onClick)="login()" styleClass="p-button-primary"></p-button>
    </div>
  `
})
export class LogoutComponent implements OnInit {
  private auth = inject(AppAuthService);

  ngOnInit(): void {
    this.auth.logout();
  }

  login() {
    this.auth.login();
  }
}
